import { render, staticRenderFns } from "./ProfileItem.vue?vue&type=template&id=88068f80&scoped=true"
import script from "./ProfileItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileItem.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88068f80",
  null
  
)

export default component.exports